import { render, staticRenderFns } from "./changeLocation.vue?vue&type=template&id=5124da04&scoped=true&"
import script from "./changeLocation.vue?vue&type=script&lang=js&"
export * from "./changeLocation.vue?vue&type=script&lang=js&"
import style0 from "./changeLocation.vue?vue&type=style&index=0&id=5124da04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124da04",
  null
  
)

export default component.exports